<template>
    <div>
        <div class="ctitle">{{row.title}}</div>
        <div class="ccontent" v-html="content">

        </div>
    </div>
</template>

<script>
    export default {
        name: "ContentDetail",
        components: {
        },
        data: function () {
            return {
                contentId: 0,
                row: {
                    title: ''
                },
                content: ""
            }
        },
        filter: {},
        mounted() {
            document.title = '详情';
            this.fetch()
        },
        destroyed() {
        },
        methods: {
            fetch() {
                let that = this;
                // let contentId = this.$route.query.id =5;
                let contentId = this.$route.query.id;

                this.$api.get('/api/cms/detail', {id: contentId}, (res) => {
                    that.row = res.data.data;
                    that.content = res.data.data.content;
                    document.title = that.row.title;
                    
                    that.wxShare(res.data.share_data.title, res.data.share_data.desc, res.data.share_data.url, res.data.share_data.pic_url);

                })
            }
        }
    }
</script>

<style scoped>
    .ctitle{ padding: 10px; border: 1px solid #eee; }
    .ccontent{ padding: 10px; line-height: 20px; }

    /*.ccontent >>> p:first-child {*/
    /*    height: 0;*/
    /*}*/

    .ccontent >>> img {
        /*width:365px;*/
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// ContentDetail.vue?543426ca